/**
 * The NE Dances brand, for places that cannot read the CSS theme.
 *
 * The theme itself lives in `styles/globals.css` ("cosmic-night", violet on
 * indigo) and everything rendered by the app should use its tokens —
 * `bg-background`, `text-primary` and so on — so light and dark both work.
 * This file is only for what sits outside the page's CSS: the generated share
 * image, the browser `theme-color`, the web manifest, map markers drawn by
 * Google Maps.
 *
 * Each value is the sRGB hex of the matching `oklch(...)` token, and
 * `brand.test.ts` fails if they drift apart. Change the theme in globals.css
 * first, then update these to match.
 *
 * The logo is `src/components/ui/Logo.tsx` (the dancing couple and wordmark);
 * `src/pages/favicon.svg` and the PNG icons are copies of its dancers. The
 * gold "N" monogram and the `#C9A87C` / `#0C0A14` palette were placeholders
 * from before this theme and are retired — do not bring them back.
 */
export const BRAND = {
  light: {
    background: "#F5F5FF",
    foreground: "#2A2A4A",
    card: "#FFFFFF",
    primary: "#6E56CF",
    mutedForeground: "#6C6C8A",
  },
  dark: {
    background: "#0F0F1A",
    foreground: "#E2E2F5",
    card: "#1A1A2E",
    primary: "#A48FFF",
    mutedForeground: "#A0A0C0",
  },
} as const;

/** Which `globals.css` token each value above copies, for the drift test. */
export const BRAND_TOKENS = {
  background: "--background",
  foreground: "--foreground",
  card: "--card",
  primary: "--primary",
  mutedForeground: "--muted-foreground",
} as const satisfies Record<keyof typeof BRAND.light, string>;
